var React = require('react');

function CommentAltEdit (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 0H64A64.06 64.06 0 0 0 0 64v288a64.06 64.06 0 0 0 64 64h96v84a12 12 0 0 0 19.1 9.7L304 416h144a64.06 64.06 0 0 0 64-64V64a64.06 64.06 0 0 0-64-64zM215.4 310.6l-48.2 5.4a10.17 10.17 0 0 1-11.2-11.2l5.4-48.2 96.3-96.3 54 54zm150.7-150.7l-31.8 31.8-54-54 31.8-31.8a20.22 20.22 0 0 1 28.6 0l25.4 25.4a20.22 20.22 0 0 1 0 28.6z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M161.4 256.6l-5.4 48.2a10.17 10.17 0 0 0 11.2 11.2l48.2-5.4 96.3-96.3-54-54zm204.7-125.3l-25.4-25.4a20.22 20.22 0 0 0-28.6 0l-31.8 31.8 54 54 31.8-31.8a20.22 20.22 0 0 0 0-28.6z","className":"fa-primary","key":2})]);
}

CommentAltEdit.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CommentAltEdit;

CommentAltEdit.default = CommentAltEdit;
